<div
  class="tw-mt-6 tw-flex tw-w-full tw-flex-col tw-gap-6 tw-rounded-3xl tw-bg-color-surface-card tw-py-8 tw-px-12 shadow-fade-card sm:tw-px-8 sm:tw-mt-0"
>
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-text-center">
    <h1 class="tw-text-xl tw-font-semibold tw-text-dt-text-headings">
      {{ "acceptTeamInvitation" | i18n }}
    </h1>
    @if (!fatal) {
      <p class="tw-text-sm tw-text-dt-text-tertiary">
        {{
          (isAuthenticated ? "acceptTeamInviteBodyLoggedIn" : "acceptTeamInviteBodyLoggedOut")
            | i18n: inviterDisplay
        }}
      </p>
    }
  </div>

  <!-- Only a fatal error (bad link, invite gone, decline rejected for good) replaces the card.
       Anything else shows above it: a retryable one (e.g. a dropped connection) keeps Accept /
       Decline / Skip, a permanent accept failure hides only Accept (acceptBlocked), and a
       permanent org-invite decline failure only Decline (declineBlocked). -->
  @if (error) {
    <div
      class="tw-rounded tw-bg-dt-surface-out tw-p-3 tw-text-sm tw-text-dt-text-error"
      role="alert"
    >
      {{ error }}
    </div>
  }
  @if (!fatal) {
    <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-bg-color-surface-sunken tw-p-4">
      <div class="tw-flex tw-items-center tw-gap-3">
        <!-- Same team avatar as the rows on the Teams page. -->
        <div
          class="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-brand tw-font-montserrat tw-text-lg tw-font-semibold tw-leading-none tw-text-color-intent-brand"
        >
          {{ avatarInitial }}
        </div>
        <div class="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-1">
          <span
            class="tw-truncate tw-text-sm tw-font-semibold tw-leading-5 tw-text-dt-text-headings"
            >{{ teamName }}</span
          >
          <span class="tw-truncate tw-text-xs tw-leading-4 tw-text-dt-text-tertiary">{{
            cardSubtitle
          }}</span>
          <span [ngClass]="badgeClass['owner']">{{ "invitationBadge" | i18n }}</span>
        </div>
      </div>
    </div>

    @if (isAuthenticated && !loading && !done) {
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
        <p class="tw-text-center tw-text-sm tw-text-dt-text-secondary">
          {{ "signedInAs" | i18n: currentUserEmail }}
        </p>
        @if (isDifferentAccount) {
          <p class="tw-text-center tw-text-sm tw-text-dt-text-error">
            {{ "inviteSentToDifferentAccount" | i18n: invitedEmail }}
          </p>
        } @else {
          <!-- Hidden once the backend has rejected the accept for good; Decline / Skip stay, and
               the reason takes its place unless the alert above already says it. -->
          @if (acceptBlocked) {
            @if (acceptBlockedReason && acceptBlockedReason !== error) {
              <p
                class="tw-m-0 tw-text-center tw-text-sm tw-text-dt-text-error"
                data-testid="accept-blocked-reason"
              >
                {{ acceptBlockedReason }}
              </p>
            }
          } @else {
            <app-gloss-button
              class="tw-w-full"
              [options]="{
                text: 'acceptInvitation' | i18n,
                fullClass: primaryButtonClass,
                ghostShadow: true,
                isEnabled: true,
                onClick: accept.bind(this),
              }"
              [fontClass]="'!tw-font-semibold'"
            ></app-gloss-button>
          }
          @if (!declineBlocked) {
            <button
              type="button"
              class="tw-text-sm tw-font-medium tw-text-color-text-action"
              (click)="declineInvitation()"
            >
              {{ "declineInvitation" | i18n }}
            </button>
          }
        }
        <button
          type="button"
          class="tw-mt-6 tw-text-xs tw-text-dt-text-tertiary"
          (click)="skipForNow()"
        >
          {{ "skipForNow" | i18n }}
        </button>
      </div>
    }

    @if (done && !loading) {
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
        <p class="tw-text-center tw-text-sm tw-text-dt-text-secondary">
          {{ doneMessageKey | i18n }}
        </p>
        <app-gloss-button
          class="tw-w-full"
          [options]="{
            text: 'continue' | i18n,
            fullClass: primaryButtonClass,
            ghostShadow: true,
            isEnabled: true,
            onClick: continueAfterDone.bind(this),
          }"
          [fontClass]="'!tw-font-semibold'"
        ></app-gloss-button>
      </div>
    }

    @if (!isAuthenticated) {
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
        <p class="tw-text-center tw-text-xs tw-text-dt-text-tertiary">
          {{ "loginToAccept" | i18n }}
        </p>
        <app-gloss-button
          class="tw-w-full"
          [options]="{
            text: 'logInToAccept' | i18n,
            fullClass: primaryButtonClass,
            ghostShadow: true,
            isEnabled: true,
            onClick: navigateToLogin.bind(this),
          }"
          [fontClass]="'!tw-font-semibold'"
        ></app-gloss-button>
        <button
          type="button"
          class="tw-text-sm tw-font-medium tw-text-color-text-action"
          (click)="skipForNow()"
        >
          {{ "notYouIgnoreInvitation" | i18n }}
        </button>
      </div>
    }

    @if (loading) {
      <div class="tw-flex tw-justify-center tw-py-4">
        <i
          class="bwi bwi-spinner bwi-spin tw-text-2xl tw-text-dt-text-disabled"
          aria-hidden="true"
        ></i>
      </div>
    }
  }
</div>
